"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gdprString = gdprString;
exports.gdprData = gdprData;
/**
 * Anonimizuje dane tekstowe
 * @param s tekst wejsciowy
 * @param gdprMode tryb anonimizacji
 * @returns
 */
function gdprString(s, gdprMode = '***') {
    if (s == undefined) {
        return undefined;
    }
    switch (gdprMode) {
        case '***':
            return '***';
        case 'a**b': {
            const st = s.split(' ').reduce((a, b) => {
                if (b.length >= 2) {
                    a.push(b.substring(0, 1) + '**' + b.substring(b.length - 1));
                }
                return a;
            }, []);
            if (st.length == 0)
                return '***';
            else
                return st.join(' ');
        }
        default:
            return undefined;
    }
}
/**
 * Anonimizuje dane wrażliwe, oznacozne jako GDPR
 * @param schema schemat
 * @param data dane
 * @param gdprMode tryb anonimizacji
 * @returns
 */
function gdprData(schema, data, gdprMode = '***') {
    if (schema.gdpr) {
        switch (schema.type) {
            case 'array':
                return schema.default ? Array.from(schema.default) : undefined;
            case 'object':
                return undefined;
            case 'string':
                return gdprString(data, gdprMode);
            default:
                return undefined;
        }
    }
    if (schema.type === 'object') {
        if (typeof data !== 'object') {
            return undefined;
        }
        if (data === null) {
            return null;
        }
        const result = {};
        const props = schema.properties;
        if (props) {
            for (const key in props) {
                const value = data[key];
                const element = props[key];
                if (value !== undefined) {
                    const nvalue = gdprData(element, value, gdprMode);
                    if (nvalue !== undefined) {
                        result[key] = nvalue;
                    }
                }
            }
        }
        return result;
    }
    else if (schema.type === 'array') {
        if (Array.isArray(data)) {
            const result = [];
            const items = schema.items;
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < data.length; i++) {
                const nvalue = gdprData(items, data[i], gdprMode);
                if (nvalue !== undefined) {
                    result.push(nvalue);
                }
            }
            return result;
        }
        else {
            return undefined;
        }
    }
    else {
        return data;
    }
}
//# sourceMappingURL=gpdrData.js.map